import * as actionTypes from "../Actions/actionTypes.js";

const initialState = {
  currency: "CAD"
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CURRENCY:
      return { ...state, currency: action.value };
    default:
      return state;
  }
};

export default reducer;
